import { render, staticRenderFns } from "./ReportCategoryForm.vue?vue&type=template&id=255770da&scoped=true&"
import script from "./ReportCategoryForm.vue?vue&type=script&lang=js&"
export * from "./ReportCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./ReportCategoryForm.vue?vue&type=style&index=0&id=255770da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255770da",
  null
  
)

export default component.exports